export const EldMalfunctionsTranslationsDictionary =
{
    NoMalfunctions: "You have no ELD malfunctions",
    MalfunctionNotifications: "Malfunction notifications",
    PowerMalfunction: "Power Malfunction",
    PowerDiagnostic: "Power Diagnostic",
    EngineSyncMalfunction: "Engine Sync Malfunction",
    EngineSyncDiagnostic: "Engine Sync Diagnostic",
    TimingMalfunction: "Timing Malfunction",
    TimingDiagnostic: "Timing Diagnostic",
    PositioningMalfunction: "Positioning Malfunction",
    PositioningDiagnostic: "Positioning Diagnostic",
    DataRecordingMalfunction: "Data Recording Malfunction",
    DataRecordingDiagnostic: "Data Recording Diagnostic",
    DataTransferMalfunction: "Data Transfer Malfunction",
    DataTransferDiagnostic: "Data Transfer Diagnostic",
    OtherMalfunction: "Other Malfunction",
    OtherDiagnostic: "Other Diagnostic",
    MissingElementMalfunction: "Missing Element Malfunction",
    MissingElementDiagnostic: "Missing Element Diagnostic",
    UnidentifiedDrivingMalfunction: "Unidentified Driving Malfunction",
    UnidentifiedDrivingDiagnostic: "Unidentified Driving Diagnostic",
    Help: "Help",
    Cleared: "Cleared",
    Clear: "Clear",
    OK: "OK",
    Error: "Error"
};

let getTranslations = () => {
    let r: string[] = [];
    for (const prop in EldMalfunctionsTranslationsDictionary) {
        r.push(EldMalfunctionsTranslationsDictionary[prop]);
    }
    return r;
};

export const EldMalfunctionsTranslations = getTranslations();